import { Product } from 'types/products';

const getProductType = (product: Product): string => {
  const productType = product?.identification?.product_type;
  if (productType && ['Réfrigérateur', 'Congélateur'].includes(productType) && product.subcategory1)
    return product.subcategory1;
  return productType || '';
};

const getProductBrand = (product: Product): string => {
  const brand = product?.identification?.brand;
  return (brand && ` • ${brand}`) || '';
};

export const formatProductTitle = (product: Product): string => {
  return getProductType(product) + getProductBrand(product);
};

export const PRODUCT_FUNCTIONAL_STATUS_WORKING = 'working';
export const PRODUCT_FUNCTIONAL_STATUS_NOT_WORKING = 'not_working';
export const PRODUCT_FUNCTIONAL_STATUS = [
  PRODUCT_FUNCTIONAL_STATUS_WORKING,
  PRODUCT_FUNCTIONAL_STATUS_NOT_WORKING,
];

export type ProductFunctionnalStatusScreenFormValue = {
  isRepaired: string;
};
